import { Coords } from "../interfaces/Coords";

const gap: number = 4;
const dropdownItemHeight: number = 40;
const maxVisibleDropDownItems: number = 5;

export const getDropdownCoords = (
  elem: HTMLButtonElement | null,
  bodyHeight: number,
): Coords => {
  const { innerHeight, scrollY } = window;
  const elemData: DOMRect | undefined = elem?.getBoundingClientRect();

  const elemHeight: number = elemData?.height ?? 0;
  const elemTop: number = elemData?.top ?? 0;
  // Prefer opening below if it fits, otherwise above. Fallback to below.
  const spaceAbove: number = elemTop; // space from viewport top to button top
  const spaceBelow: number = innerHeight - (elemTop + elemHeight); // space from button bottom to viewport bottom

  const fitsBelow: boolean = bodyHeight + gap <= spaceBelow;
  const fitsAbove: boolean = bodyHeight + gap <= spaceAbove;

  let top: number;
  if (fitsBelow) {
    // Open below the button with a gap
    top = scrollY + elemTop + elemHeight + gap;
  } else if (fitsAbove) {
    // Open above the button with a gap
    top = scrollY + elemTop - bodyHeight - gap;
  } else {
    // Fallback: open below even if it doesn't fully fit
    top = scrollY + elemTop + elemHeight + gap;
  }
  const left: number = elemData?.left ?? 0;
  // Ensure top is not negative
  if (top < 0) top = 0;

  const coords: Coords = {
    left,
    top,
  };
  return coords;
};

export const getDropdownWidth = (elem: HTMLButtonElement | null): number =>
  elem?.getBoundingClientRect().width ?? 0;

export const getDropdownBodyHeight = (
  itemsLength: number,
  maxVisible?: number,
  withFilter = false,
): number => {
  let height = (itemsLength + (withFilter ? 1.5 : 0)) * dropdownItemHeight;

  const effectiveMaxVisible = maxVisible ?? maxVisibleDropDownItems;
  if (itemsLength > effectiveMaxVisible)
    height = dropdownItemHeight * effectiveMaxVisible;

  return height;
};

export const getRootPopup = (): HTMLElement => {
  let PopupRoot = document.getElementById("popup-root");

  if (PopupRoot === null) {
    PopupRoot = document.createElement("div");
    PopupRoot.setAttribute("id", "popup-root");
    document.body.appendChild(PopupRoot);
  }

  return PopupRoot;
};
